import type React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { APP_NAME } from "@/lib/constants";

const Footer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentYear = new Date().getFullYear();
  const isJapanese = i18n.language === "ja";

  return (
    <footer className="border-t border-gray-200 dark:border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-[11px] text-gray-400">
            © {currentYear} {APP_NAME}
          </p>
          <nav className="flex items-center gap-3 text-[11px] text-gray-400">
            <Link
              to="/terms"
              className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              {t("footer.terms")}
            </Link>
            <span className="text-gray-300 dark:text-gray-600">|</span>
            <Link
              to="/privacy"
              className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              {t("footer.privacy")}
            </Link>
            <span className="text-gray-300 dark:text-gray-600">|</span>
            <Link
              to="/legal/commercial"
              className="hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            >
              {isJapanese ? t("footer.sellerInfo") : t("footer.sellerInfo")}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
